import { FormControl, InputLabel, MenuItem, Select } from "@material-ui/core";
import classNames from "classnames";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import Autocomplete from "@mui/material/Autocomplete";
import Popper from "@mui/material/Popper";

// Custom Popper to increase dropdown width
const CustomPopper = ({ options, ...popperProps }) => {
  const hasLongString50 =
    Array.isArray(options) && options.length > 0
      ? options.some((str) => typeof str === "string" && str.length > 50)
      : false;

  const hasLongString70 =
    Array.isArray(options) && options.length > 0
      ? options.some((str) => typeof str === "string" && str.length > 70)
      : false;
  return (
    <Popper
      {...popperProps}
      modifiers={[
        {
          name: "offset",
          options: {
            offset: [0, 4],
          },
        },
      ]}
      style={{
        width: hasLongString70 ? "400px" : hasLongString50 ? "450px" : "400px", // Set desired dropdown width
      }}
    />
  );
};

const CustomSelect = ({
  name,
  value,
  selectMessage,
  options,
  classes,
  tableName,
  customStyles,
  readonly,
  rowHasError,
  errorMessage,
  showLabel = true,
  sourceData,
  ...props
}) => {
  const handleSelect = (key, val) => {
    props.onChange(key, val);
  };

  const hasLongString =
    Array.isArray(options) && options.length > 0
      ? options.some((str) => typeof str === "string" && str.length > 25)
      : false;
  const safeOptions = Array.isArray(options)
    ? options.filter((opt) => typeof opt === "string")
    : [];

  const derivedValueCheck = (value) => {
    const DERIVED_TYPE_DETAILS =
      sourceData?.data?.dropdown?.derived_target_column_name_details || {};

    const Derived_Options = props?.derivedOptions;

    // ✅ Safety check
    if (
      !Derived_Options ||
      typeof Derived_Options !== "object" ||
      Array.isArray(Derived_Options)
    ) {
      return {
        color: "",
        isDerived: false,
        derived_category: "",
      };
    }

    // ✅ Find matching derived key
    const Derived_Result = Object.keys(Derived_Options).find(
      (key) => key === value
    );

    // ✅ Get color value
    const derivedValue = Derived_Result
      ? Derived_Options[Derived_Result]
      : null;

    // ✅ Find matching derived type
    const Derived_Type =
      DERIVED_TYPE_DETAILS &&
      typeof DERIVED_TYPE_DETAILS === "object" &&
      derivedValue
        ? Object.keys(DERIVED_TYPE_DETAILS).find((key) => {
            const typeVal = DERIVED_TYPE_DETAILS[key];

            return (
              typeof typeVal === "string" &&
              typeof derivedValue === "string" &&
              typeVal.toLowerCase() === derivedValue.toLowerCase()
            );
          })
        : "";

    // ✅ Final object to return
    const result = {
      color: derivedValue || "",
      isDerived: !!Derived_Result,
      derived_category: Derived_Type,
    };

    return result;
  };

  return (
    <FormControl
      className={classNames(
        classes.selectFormControl,
        `selectFormControl_${tableName}`
      )}
      style={{ width: "100%" }}
      disabled={options.length === 0 ? true : false}
    >
      {/* Select with search bar  */}
      <div className="grid-container">
        {showLabel && (
          <label className="label-style" htmlFor={name}>
            {selectMessage}
          </label>
        )}
        <Stack spacing={2} sx={{ width: "100%" }}>
          {hasLongString ? (
            <Autocomplete
              PopperComponent={(props) => (
                <CustomPopper
                  {...props}
                  options={options && options.length > 0 ? options : []}
                />
              )}
              disabled={readonly}
              id="disable-clearable"
              disableClearable
              size="small"
              options={typeof value === "string" ? safeOptions : options}
              onChange={(event, newValue) => handleSelect(name, newValue)}
              isOptionEqualToValue={(option, value) => option === value}
              sx={{
                "& .MuiAutocomplete-input": {
                  fontSize: "12px",
                  fontWeight: "normal",
                },
              }}
              value={value ?? null}
              // defaultValue={value || ""}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="standard"
                  sx={{ fontSize: "12px" }}
                />
              )}
              renderOption={(props, option, { index }) => {
                let isDerived;
                if (
                  sourceData?.data?.dropdown?.derived_target_column_name_details
                ) {
                  isDerived = derivedValueCheck(option);
                }

                return (
                  <li
                    {...props}
                    key={`${option}-${index}`}
                    style={{
                      fontSize: "12px",
                      fontWeight: "normal",
                      color: "#212529",
                    }}
                  >
                    <div
                      style={{
                        position: "relative",
                        width: "100%",
                      }}
                    >
                      <span>{option}</span>
                      {sourceData?.data?.dropdown
                        ?.derived_target_column_name_details && (
                        <span
                          style={{
                            position: "absolute",
                            top: "0px",
                            marginLeft: "10px",
                          }}
                        >
                          {isDerived &&
                            isDerived.isDerived &&
                            name === "TARGET_COLUMN_NAME" && (
                              <span
                                style={{
                                  color: `${
                                    isDerived &&
                                    isDerived.isDerived &&
                                    name === "TARGET_COLUMN_NAME"
                                      ? isDerived.color
                                      : ""
                                  }`,
                                  fontSize: "11px",
                                  fontWeight: "800",
                                  border: `2px solid ${isDerived.color}`,
                                  borderRadius: "50%",
                                  padding: "0px 4px",
                                }}
                              >
                                {isDerived.derived_category?.[0] || ""}
                              </span>
                            )}
                        </span>
                      )}
                    </div>
                  </li>
                );
              }}
              getOptionLabel={(option) =>
                option !== undefined && option !== null ? String(option) : ""
              }
            />
          ) : (
            <Autocomplete
              disabled={readonly}
              id="disable-clearable"
              disableClearable
              size="small"
              options={typeof value === "string" ? safeOptions : options}
              onChange={(event, newValue) => handleSelect(name, newValue)}
              isOptionEqualToValue={(option, value) => option === value}
              sx={{
                "& .MuiAutocomplete-input": {
                  fontSize: "12px",
                  fontWeight: "normal",
                },
              }}
              value={value ?? null}
              // defaultValue={value || ""}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="standard"
                  sx={{ fontSize: "12px" }}
                />
              )}
              renderOption={(props, option, { index }) => {
                const isDerived = derivedValueCheck(option);

                return (
                  <li
                    {...props}
                    style={{
                      fontSize: "12px",
                      fontWeight: "normal",
                      color: "#212529",
                    }}
                    key={`${option}-${index}`}
                  >
                    <div
                      style={{
                        position: "relative",
                        width: "100%",
                      }}
                    >
                      <span>{option}</span>
                      <span
                        style={{
                          position: "absolute",
                          top: "0px",
                          marginLeft: "10px",
                        }}
                      >
                        {isDerived &&
                          isDerived.isDerived &&
                          name === "TARGET_COLUMN_NAME" && (
                            <span
                              style={{
                                color: `${
                                  isDerived &&
                                  isDerived.isDerived &&
                                  name === "TARGET_COLUMN_NAME"
                                    ? isDerived.color
                                    : ""
                                }`,
                                fontSize: "12px",
                                fontWeight: "800",
                                border: `2px solid ${isDerived.color}`,
                                borderRadius: "50%",
                                padding: "0px 4px",
                              }}
                            >
                              {isDerived.derived_category?.[0] || ""}
                            </span>
                          )}
                      </span>
                    </div>
                  </li>
                );
              }}
              getOptionLabel={(option) =>
                option !== undefined && option !== null ? String(option) : ""
              }
            />
          )}
        </Stack>
        {rowHasError && options.length !== 0 && (
          <label style={{ color: "red" }}>{errorMessage}</label>
        )}
      </div>
    </FormControl>
  );
};

export default CustomSelect;
